<div class="py-base px-xl text-base leading-base font-semibold text-txt">{{ data.title }}</div>
<div class="mb-base">
  @for (item of data.items; track item) {
    <div
      class="py-base px-xl cursor-pointer hover:bg-ui-hover text-txt text-base leading-base"
      [ngClass]="{ '!bg-ui-hover-1': item.value === data.selectedItem }"
      (click)="selectItem(item.value)"
      >
      {{ item.label }}
    </div>
  }
</div>
